<template>
  <el-cascader
    ref="cascaderAddr"
    placeholder="增加篩選條件"
    v-model="value"
    :options="options"
    @change="handleChange"
  ></el-cascader>
</template>
<script>
import EnterpriseAPI from '../../../assets/js/libs/EnterpriseAPI'

export default {
  props: ['options'],
  methods: {
    handleChange(val) {
      let object = {
        key: val[0],
        value: val[1],
        title:
          this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels[0] +
          '/' +
          this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels[1],
      }
      this.$emit('selectFilter', object)
      // BUG: 讓下拉選單的內容維持於input中，將line24註解
      // this.value =[];
    },
    setOptionChildren(obj) {
      this.options.push(obj)
    },
  },
  mounted() {
    EnterpriseAPI.get(`enterprise/`)
      .then((res) => {
        let company = res.result.list
        let condition = {
          value: 'enterprise_id',
          label: '選擇企業',
          children: [],
        }
        for (let i = 0; i < company.length; i++) {
          condition.children.push({
            value: company[i].id,
            label: company[i].name,
          })
        }
        this.setOptionChildren(condition)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  data() {
    return {
      value: '',
    }
  },
}
</script>
<style scoped>
.el-cascader {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/element_ui/filter_componet/Filter.vue